import { menuSeconds } from "../../constants/menu";
import AgentDetail from "../../pages/auth/agentDetail";
import EditProfile from "../../pages/auth/editProfile";
import EditProfileAdmin from "../../pages/auth/editProfileAdmin";
import { getProfile } from "../../utils/app.utils";
import { routeName } from "../routers-name";
import { decode } from 'js-base64';

const profile: any = JSON.parse(getProfile() || '{}')
const role : any = profile.length > 3 ? JSON.parse(decode(profile)) : '{}'

const routeEditProfile = [
 
  {
    ...menuSeconds.EDIT_PROFILE,
    key: menuSeconds.EDIT_PROFILE.key,
    name: menuSeconds.EDIT_PROFILE.name,
    textName: menuSeconds.EDIT_PROFILE.textName,
    path: routeName.editProfile,
    active: false,
    appBar: true,
    component: role.roleId == 4 ? EditProfile : EditProfileAdmin,
  },
  {
    ...menuSeconds.EDIT_AGENT_PROFILE,
    key: menuSeconds.EDIT_AGENT_PROFILE.key,
    name: menuSeconds.EDIT_AGENT_PROFILE.name,
    textName: menuSeconds.EDIT_AGENT_PROFILE.textName,
    path: routeName.agentProfile + '/:id',
    active: false,
    appBar: true,
    component: AgentDetail,
  },
  {
    ...menuSeconds.ADD_AGENT_PROFILE,
    key: menuSeconds.ADD_AGENT_PROFILE.key,
    name: menuSeconds.ADD_AGENT_PROFILE.name,
    textName: menuSeconds.ADD_AGENT_PROFILE.textName,
    path: routeName.agentProfile + '-add',
    active: false,
    appBar: true,
    component: AgentDetail,
  },
];

export default routeEditProfile;
